package com.example.mystybag.appCore.logic.pages

import com.example.mystybag.appCore.model.pages.StoredCardsUIState
import com.example.mystybag.communication.common.CommonCommands
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.helpers.GlobalCommonData.getUserIdValue
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.sharedmodels.mystyBag.requestModels.GetUserStoredCardsRequestModel
import kotlinx.coroutines.launch

class StoredCardsViewModel(
    context: AppContext
) : ChildViewModel<StoredCardsUIState>(context, StoredCardsUIState()) {

    override fun onCreate() {
        navControls.backButtonVisible = true
        navControls.title = sharedString(SR.strings.stored_cards_title)
        loadCards()
    }

    private fun loadCards() {
        val userId = getUserIdValue()
        if (userId <= 0L) return

        scope.launch {
            updateState { it.copy(isLoading = true) }
            commandBlock(showProgress = false, hideProgress = false) {
                CommonCommands.getUserStoredCards(
                    request = GetUserStoredCardsRequestModel(userId = userId)
                ).onResponse(
                    success = { response ->
                        val model =
                            response as? com.example.mystybag.sharedmodels.mystyBag.responseModels.GetUserStoredCardsResponseModel
                        launchOnMain {
                            updateState {
                                it.copy(
                                    cards = model?.cards ?: emptyList(),
                                    isLoading = false
                                )
                            }
                        }
                    },
                    baseError = {
                        launchOnMain {
                            updateState { state -> state.copy(isLoading = false) }
                        }
                    }
                )
            }
        }
    }
}
